import { IWizardStep, IWizardStepsGroup } from '../models/IWizardStep'

export const isWizardStepsGroup = (
  item: IWizardStep | IWizardStepsGroup
): item is IWizardStepsGroup => {
  return (item as IWizardStepsGroup).steps !== undefined
}
